import BaseService from './baseService';

export default {
  getArquivosListar(numCgcFornecedor) {
    const parametros = "numCgcFornecedor="+numCgcFornecedor;
    return BaseService.get("arquivo/listar"+parametros);
  },

  obterDocumentosGuias(perfil) {
    
    return BaseService.get("arquivo/obterDocumentosGuias?perfil=" + perfil);
  },

  salvar(model) {    
    return BaseService.post("arquivo/uploadArquivoBD", model);
  },

  editar(model) {    
    return BaseService.post("arquivo/editarArquivoBD", model);
  },

  delete(model) {
    const parametros = "numCgcFornecedor="+ model.numCgcFornecedor + "&ArquivoUpload="+model.ArquivoUpload;
    return BaseService.delete("familia/excluirfamiliasolicitacao?"+parametros);
  },

  excluirDocumento(id_arquivo) {
    return BaseService.delete("arquivo/deletar/"+id_arquivo);
  },

  retornaArqsPerfis(id_perfil) {  
    return BaseService.get("arquivo/getPerfil/"+id_perfil);
  },

};
